import { useState } from "react";
import Styles from "./Unified_Ledger.module.css";
import Header from "./Header";
import Bilateral from "./Bilateral";
import TradeConnect from "./TradeConnect";
import RA from "./RA";

const UnifiedLedger = () => {
  const STATUSES = ["Bilateral", "TradeConnect", "Reverse Auction"];
  const [status, setStatus] = useState(STATUSES[0]);

  return (
    <>
      <div className={Styles.bankingSearchMainCont}>
        <Header STATUSES={STATUSES} status={status} setStatus={setStatus} />

        <div
          style={{
            padding: "10px",
            overflowX: "auto",
            height: "calc(100vh - 180px)",
          }}
        >
          {status === "Bilateral" && (
            <>
              <Bilateral />
            </>
          )}
          {status === "TradeConnect" && (
            <>
              <TradeConnect />
            </>
          )}
          {status === "Reverse Auction" && (
            <>
              <RA />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default UnifiedLedger;
